<div class="caret-icon">
  <ion-icon
    *ngIf="sortField !== fieldName || sortDirection !== SortDirection.DESC"
    name="caret-up-outline"
  ></ion-icon>
  <ion-icon
    *ngIf="sortField !== fieldName || sortDirection !== SortDirection.ASC"
    name="caret-down-outline"
  ></ion-icon>
</div>
